import React from 'react';

const defaultValue = {
  locale: 'en',
  // eslint-disable-next-line
  setLocale: () => {},
};

export default React.createContext(defaultValue);
